import React, { useEffect } from "react";

import Main from '../components/AccountTypes/Main'
import SimpleSteps from "../components/Home/SimpleSteps";
import FAQ from "../components/AccountTypes/FAQ";

function AccountTypes () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#E6E3E6]">
            <Main/>
            <FAQ/>
            <SimpleSteps/>
        </div>
    );
}

export default AccountTypes;